import { useTranslation } from 'react-i18next';
import { useLogger, useUserContext } from '@vp/ubik-context';
import { App } from '../app';
import { sanitiseLocale } from '../app/i18n/config';
import BusinessNameGeneratorPage from '../app/pages/BusinessNameGeneratorPage';
import { IndustryBusinessNameIdeasData } from '../app/pages/BusinessNameGeneratorPage/components/content/explore-business-ideas-data';
import { DefaultPageTrackingParams } from '../app/utils/analytics';
import type { Logger } from '@vp/ubik-logging';
import type { Translation } from '../@types/resources';
import type { EnvironmentContextType } from '../app/utils/environmentContext';

export interface Props {
    translation: Translation;
    envContext: EnvironmentContextType;
    industryBusinessNameIdeasData: IndustryBusinessNameIdeasData;
}

const defaultPageTrackingParams: DefaultPageTrackingParams = {
    route: '/business-name-generator',
};

export const Fragment = ({ translation, envContext, industryBusinessNameIdeasData }: Props) => {
    const { ENV_QUALAROO_SURVEY_URL } = envContext;
    const logger: Logger = useLogger();
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(useUserContext().locale);

    logger.info(`Rendering Business Name Generator fragment for the locale ${locale}`);

    i18n.addResourceBundle(locale, 'translation', translation).changeLanguage(locale);

    return (
        <App
            defaultPageTrackingParams={defaultPageTrackingParams}
            locale={locale}
            envContext={envContext}
        >
            <BusinessNameGeneratorPage
                industryBusinessNameIdeasData={industryBusinessNameIdeasData}
            />
            <script src={ENV_QUALAROO_SURVEY_URL} />
        </App>
    );
};
